import request from "@/utils/request";
const dealSettlBaseUrl = `${process.env.VUE_APP_TREASURY_BASEURL}/api/v1/fund-settlement`;
const FundingBaseUrl = `${process.env.VUE_APP_TREASURY_BASEURL}/api/v1/prefund-voucher`;
const BussinessDealBaseUrl = `${process.env.VUE_APP_TREASURY_BASEURL}/api/v1/business`;
const NewBUSDealBaseUrl = `${process.env.VUE_APP_TREASURY_BASEURL}/api/v1/new-contract`;
const NewDealBaseUrl = `${process.env.VUE_APP_TREASURY_BASEURL}/api/v1/forex-deal`;
const VoucherBaseUrl = `${process.env.VUE_APP_TREASURY_BASEURL}/api/v1/voucher`;

export default {
  //------------------------TRESURE SETTLEMENT----------------------------------------//
  getVoucherReportByDate(params) {
    return request({
      url: `${VoucherBaseUrl}/get-voucher-report`,
      method: "GET",
      params: params,
    });
  },

  getSelectedSettledDeal(deal_id) {
    return request({
      url: `${dealSettlBaseUrl}/get-settlement-by-contract?deal_id=${deal_id}`,
      method: "GET",
    });
  },
  getSelectedFundSettDeal(settlement_id) {
    return request({
      url: `${dealSettlBaseUrl}/get-fund-settlement-by-id?settl_id=${settlement_id}`,
      method: "GET",
    });
  },
  addNewSettleDeal(data) {
    return request({
      url: `${dealSettlBaseUrl}/new-fund-settlement`,
      method: "POST",
      data,
    });
  },
  postSettlementDeal(settl_id, data) {
    return request({
      url: `${dealSettlBaseUrl}/update-settlement?settl_id=${settl_id}`,
      method: "PUT",
      data,
    });
  },
  deleteSettlementDeal(settl_id) {
    return request({
      url: `${dealSettlBaseUrl}/delete-settlement?settl_id=${settl_id}`,
      method: "DELETE",
    });
  },
  //----------------------------------TRESURE FUNDING--------------------------------//

  getSelectedFundings(settlement_id) {
    return request({
      url: `${FundingBaseUrl}/get-prefund-by-settlement?settl_id=${settlement_id}`,
      method: "GET",
    });
  },

  getSelectedPreFund(routerDataItem) {
    return request({
      url: `${FundingBaseUrl}/get-prefund?fund_id=${routerDataItem}`,
      method: "GET",
    });
  },
  checkValidity(funding_number) {
    return request({
      url: `${FundingBaseUrl}/validate-fund-num?funding_number=${funding_number}`,
      method: "GET",
    });
  },
  addFunding(data) {
    return request({
      url: `${FundingBaseUrl}/create-prefund-voucher`,
      method: "POST",
      data,
    });
  },
  updateFunds(fund_id, data) {
    return request({
      url: `${FundingBaseUrl}/update-prefund?fund_id=${fund_id}`,
      method: "PUT",
      data,
    });
  },

  deleteFund(selectedID) {
    return request({
      url: `${FundingBaseUrl}/delete-prefund?fund_id=${selectedID}`,
      method: "DELETE",
    });
  },

  //---------------------------TRESURE DEALS--------------------------------//

  getAllContract() {
    return request({
      url: `${NewDealBaseUrl}/get-all-deals`,
      method: "GET",
    });
  },
  getSelectedDeal(deal_id) {
    return request({
      url: `${NewDealBaseUrl}/get-deal-by-id?deal_id=${deal_id}`,
      method: "GET",
    });
  },
  validateDeal(deal_no) {
    return request({
      url: `${NewDealBaseUrl}/validate-deal-no?deal_no=${deal_no}`,
      method: "GET",
    });
  },
  addContract(data) {
    return request({
      url: `${NewDealBaseUrl}/new-forex-deal`,
      method: "POST",
      data,
    });
  },
  updateContract(id, data) {
    return request({
      url: `${NewDealBaseUrl}/update-deal?deal_id=${id}`,
      method: "PUT",
      data,
    });
  },
  updateContractStatus(id, status) {
    return request({
      url: `${NewDealBaseUrl}/update-status?deal_id=${id}&is_settled=${status}`,
      method: "PUT",
    });
  },
  deleteContract(deal_id) {
    return request({
      url: `${NewDealBaseUrl}/delete-deal?deal_id=${deal_id}`,
      method: "DELETE",
    });
  },
  //---------------------------TRESURE BUS DEALS--------------------------------//
  getAllBUSdeals() {
    return request({
      url: `${BussinessDealBaseUrl}/get-all-business-deals`,
      method: "GET",
    });
  },
  updateBUSdeals(deal_id, data) {
    return request({
      url: `${BussinessDealBaseUrl}/update-business-deal/${deal_id}`,
      method: "PUT",
      data,
    });
  },
  addBUSdeals(data) {
    return request({
      url: `${BussinessDealBaseUrl}/new-business-deal`,
      method: "POST",
      data,
    });
  },
  validateDealinBUS(deal_no) {
    return request({
      url: `${NewBUSDealBaseUrl}/validate-deal-no?deal_no=${deal_no}`,
      method: "GET",
    });
  },
  deleteNewContract(deal_id) {
    return request({
      url: `${NewBUSDealBaseUrl}/delete-contract/${deal_id}`,
      method: "DELETE",
    });
  },

  //-------------------------Voucher API --------------------------------------//

  getVoucherUnapprovedData() {
    return request({
      url: `${VoucherBaseUrl}/get-un-approved`,
      method: "GET",
    });
  },
  approveVoucher(params) {
    return request({
      url: `${VoucherBaseUrl}/approve`,
      method: "PUT",
      params:params,
      data:params,
    });
  },
  getVoucherexRates(data) {
    return request({
      url: `${VoucherBaseUrl}/get-ex-rates`,
      method: "POST",
      data: data,
    });
  },
  SubmitVoucherForm(data) {
    return request({
      url: `${VoucherBaseUrl}/add`,
      method: "POST",
      data: data,
    });
  },
};
